<template>
    <router-view :key="$route.path" />
</template>

<script>
    // import "primevue/resources/themes/lara-light-teal/theme.css";
    // import "primevue/resources/primevue.min.css";
    // import "primeicons/primeicons.css";

    // import "@/assets/css/default.css";
    // import "@/assets/css/main.css";
    // import "@/assets/css/primevue.css";
    // import "@/assets/css/bootstrap.css";
    // import "@/assets/css/style.css";

    import { ref, onMounted } from "vue";

    import { useStore } from "@/store";
    import { useRoute } from "vue-router";

    import { usePrimeVue } from "primevue/config";
    // import { useToast } from 'primevue/usetoast';
    // import Toast from 'primevue/toast';

    import moment from 'moment';
    import 'moment/locale/az';
    // import dayjs from 'dayjs';
    // import 'dayjs/locale/az';
    // import utc from 'dayjs/plugin/utc';


    import { G, ajax } from "@/_common";

    export default {
        name: "App",
        components: {
            // Toast,
        },
        setup() {
            const store = useStore();
            const route = useRoute();

            const TR = ref({});
            const primevue = usePrimeVue();

            G.currentRoute = route;

            moment.locale('az');

            moment.updateLocale('az', {
                months: [
                    "Yanvar", "Fevral", "Mart", "Aprel", "May", "İyun",
                    "İyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"
                ],
                monthsShort: [
                    "Yan", "Fev", "Mar", "Apr", "May", "İyn",
                    "İyl", "Avq", "Sen", "Okt", "Noy", "Dek"
                ],

                // relativeTime: {
                //     // future: "%s sonra",
                //     // past: "%s əvvəl",
                //     // s: '1 saniyə',
                //     // ss: '%d saniyə',
                //     // m: "1 dəqiqə",
                //     // mm: "%d dəqiqə",
                //     // h: "1 saat",
                //     // hh: "%d saat",
                //     // d: "1 gün",
                //     // dd: "%d gün",
                //     // M: "1 ay",
                //     // MM: "%d ay",
                //     // y: "1 il",
                //     // yy: "%d il",
                //     // M: function (number, withoutSuffix, key, isFuture) {
                //     //     console.log(number, withoutSuffix, key, isFuture);
                //     //     return number;
                //     // }
                // }
                // relativeTime: {
                //     future: "%s sonra",
                //     past: "%s əvvəl",
                //     s: '1 saniyə',
                //     ss: '%d saniyə',
                //     m: "1 dəqiqə",
                //     mm: "%d dəqiqə",
                //     h: "1 saat",
                //     hh: "%d saat",
                //     HH: "%d saat",
                //     d: "1 gün",
                //     dd: "%d gün",
                //     DD: "%d gün",
                //     M: "1 ay",
                //     MM: "%d ay",
                //     y: "1 il",
                //     yy: "%d il",
                //     YY: "%d il",
                //     // M: function (number, withoutSuffix, key, isFuture) {
                //     //     console.log(number, withoutSuffix, key, isFuture);
                //     //     return number;
                //     // }
                // }
            });

            onMounted(async() => {
                const def_lang = route.params && route.params.lang ? route.params.lang : "az";
                store.setLang(def_lang);

                await ajax({
                    url: store.getTranslations(),
                    success: (e) => {
                        // if (e && e.data) store.commit("setTranslations", e.data);
                        store.setTranslations(e.data);
                        TR.value = store.getTranslation();
                        G.lang = TR.value;
                    },
                    error: () => {
                        G.alert.error({toast: true, msg: 'Server Connection Error !'});
                        return null;
                    }
                });

                // await ajax({
                //     url: store.getSystemSettings('system'),
                //     success: (x) => {
                //         let res = x.data || null;
                //         if ( x.status == 200 && res ) {
                //             if( res.company !== undefined ){
                //                 for(let a in res){
                //                     G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                //                 }
                //                 document.getElementById("frontend_favicon1").setAttribute("href", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon2").setAttribute("href", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon3").setAttribute("href", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon_1").setAttribute("content", G.systemData?.favicon?.value );
                //                 document.getElementById("frontend_favicon_2").setAttribute("content", G.systemData?.favicon?.value );
                //             }
                //             else{
                //                 G.systemData = res;
                //             }
                //             // G.systemData = res.reduce((m, o) => m.set(o.key, o), new Map);
                //             // console.log(G.systemData);
                //             // console.log(res.reduce((m, o) => m.set(o.key, o), new Map)); //.values();
                //             // console.log(res.reduce((m, o) => m.set(o.key, {"value": o.value, "type": o.type}), new Map)); //.values();
                //         }
                //     },
                // });

                primevue.config.locale = {
                    startsWith: TR.value.startsWith,
                    contains: TR.value.contains,
                    notContains: TR.value.notContains,
                    endsWith: TR.value.endsWith,
                    equals: TR.value.equals,
                    notEquals: TR.value.notEquals,
                    noFilter: TR.value.noFilter,
                    lt: TR.value.lt,
                    lte: TR.value.lte,
                    gt: TR.value.gt,
                    gte: TR.value.gte,
                    dateIs: TR.value.dateIs,
                    dateIsNot: TR.value.dateIsNot,
                    dateBefore: TR.value.dateBefore,
                    dateAfter: TR.value.dateAfter,
                    clear: TR.value.clear,
                    apply: TR.value.apply,
                    matchAll: TR.value.matchAll,
                    matchAny: TR.value.matchAny,
                    addRule: TR.value.addRule,
                    removeRule: TR.value.removeRule,
                    accept: TR.value.accept,
                    reject: TR.value.reject,
                    choose: TR.value.choose,
                    upload: TR.value.upload,
                    cancel: TR.value.cancel,
                    dayNames: TR.value.dayNames,
                    dayNamesShort: TR.value.dayNamesShort,
                    dayNamesMin: TR.value.dayNamesMin,
                    monthNames: TR.value.monthNames,
                    monthNamesShort: TR.value.monthNamesShort,
                    today: TR.value.today,
                    weekHeader: TR.value.weekHeader,
                    firstDayOfWeek: TR.value.firstDayOfWeek,
                    dateFormat: TR.value.dateFormat,
                    weak: TR.value.weak,
                    medium: TR.value.medium,
                    strong: TR.value.strong,
                    passwordPrompt: TR.value.passwordPrompt,
                    emptyFilterMessage: TR.value.emptyFilterMessage,
                    emptyMessage: TR.value.emptyMessage,
                    // invalidFileSizeMessage: TR.value.invalidFileSizeMessage,
                    // invalidFileLimitMessage: TR.value.invalidFileLimitMessage,
                };
            });

            if( G.isTheme(G.theme) ){
                document.documentElement.style.setProperty('--main-rgb', `var(--bs-${G.theme}-rgb)`);
            }
            else{
                document.documentElement.style.setProperty('--main-rgb', `var(--bs-dark-rgb)`);
            }

            return { };
        },
    };
</script>


<style lang="scss">
    @import "~nprogress/nprogress.css";
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
        z-index: 999999;
    }
    #nprogress .spinner-icon {
        width: 48px;
        height: 48px;
        border: solid 6px transparent;
        border-top-color: rgb(23, 60, 82);
        border-left-color: rgb(23, 60, 82);
        border-radius: 50%;
    }
</style>